import styles from './info.module.css';
import { createPortal } from 'react-dom';
import React from 'react';

const Info = () => {
    return (
        <>
            {document.querySelector('#asideTitle') &&
                createPortal(
                    <h2 className={styles.info}>
                        <span>
                            Best-fit <span className={styles.highlight}>legal structures</span>:
                        </span>
                    </h2>,
                    document.querySelector('#asideTitle')!,
                )}
        </>
    );
};

export default Info;
